var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-center-coin-exchange",class:{ 'highlight': _vm.highlight }},[_c('span',[_vm._v(_vm._s(_vm.coin))]),_c('ym-img',{staticClass:"icon",attrs:{"src":require('@/assets/img/pay_center/coin_icon.png')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }